import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TemplatesModule } from '../template/template.module';
import { TextsModule } from '../texts/texts.module';
import { IndustryCardComponent } from './Industry-card/Industry-card.component';
import { BenefitCardComponent } from './benefit-card/benefit-card.component';
import { CardFooterComponent } from './card-footer/card-footer.component';
import { FeatureCardComponent } from './feature-card/feature-card.component';
import { LargeCardComponent } from './large-card/large-card.component';
import { MainCardComponent } from './main-card/main-card.component';
import { MediumCardRowComponent } from './medium-card-row/medium-card-row.component';
import { SideBySideCardComponent } from './side-by-side-card/side-by-side-card.component';
import { SmallCardXComponent } from './small-card-x/small-card-x.component';
import { SmallCardComponent } from './small-card/small-card.component';

@NgModule({
  declarations: [
    LargeCardComponent,
    SmallCardComponent,
    SmallCardXComponent,
    MediumCardRowComponent,
    MainCardComponent,
    BenefitCardComponent,
    CardFooterComponent,
    SideBySideCardComponent,
    FeatureCardComponent,
    IndustryCardComponent
  ],
  imports: [
    CommonModule,
    TemplatesModule,
    TextsModule,
    RouterModule
],
  exports: [
    LargeCardComponent,
    SmallCardComponent,
    SmallCardXComponent,
    MediumCardRowComponent,
    MainCardComponent,
    BenefitCardComponent,
    CardFooterComponent,
    SideBySideCardComponent,
    FeatureCardComponent,
    IndustryCardComponent

  ]
})
export class CardsModule { }
